export default __webpack_public_path__ + "static/media/hero_line.c7dd6c42.svg";